export const bankOptions = [
  { value: '1', label: "1 - Banco Do Brasil S.A (BB)" },
  { value: '3', label: "3 - Banco Da Amazônia S.A." },
  { value: '4', label: "4 - Banco Do Nordeste Do Brasil S.A." },
  { value: '7', label: "7 - BNDES (Banco Nacional Do Desenvolvimento Social)" },
  { value: '10', label: "10 - CREDICOAMO CRÉDITO RURAL COOPERATIVA" },
  { value: '11', label: "11 - C.Suisse Hedging-Griffo Cv S.A (Credit Suisse)" },
  { value: '12', label: "12 - Banco Inbursa" },
  { value: '14', label: "14 - Natixis Brasil S.A. / State Street Brasil S.A." },
  { value: '15', label: "15 - UBS Brasil Cctvm S.A." },
  { value: '16', label: "16 - Ccm Desp Trâns Sc E Rs" },
  { value: '17', label: "17 - Bny Mellon Banco S.A." },
  { value: '18', label: "18 - Banco Tricury S.A." },
  { value: '21', label: "21 - Banco Banestes S.A." },
  { value: '24', label: "24 - Banco Bandepe S.A." },
  { value: '25', label: "25 - Banco Alfa S.A." },
  { value: '29', label: "29 - Banco Itaú Consignado S.A." },
  { value: '33', label: "33 - Banco Santander Brasil S.A." },
  { value: '36', label: "36 - Banco Bradesco BBI S.A." },
  { value: '37', label: "37 - Banco Do Estado Do Pará S.A." },
  { value: '40', label: "40 - Banco Cargill S.A." },
  { value: '41', label: "41 - Banrisul – Banco Do Estado Do Rio Grande Do Sul S.A." },
  { value: '47', label: "47 - Banco do Estado de Sergipe S.A." },
  { value: '60', label: "60 - Confidence Cc S.A." },
  { value: '62', label: "62 - Hipercard Banco Múltiplo S.A." },
  { value: '63', label: "63 - Banco Bradescard" },
  { value: '64', label: "64 - Goldman Sachs Do Brasil Bm S.A." },
  { value: '65', label: "65 - Banco Andbank S.A." },
  { value: '66', label: "66 - Banco Morgan Stanley S.A." },
  { value: '69', label: "69 - Banco Crefisa S.A." },
  { value: '70', label: "70 - BRB – Banco De Brasília S.A." },
  { value: '74', label: "74 - Banco J. Safra S.A." },
  { value: '75', label: "75 - Bco Abn Amro S.A." },
  { value: '76', label: "76 - Banco KDB Brasil S.A." },
  { value: '77', label: "77 - Banco Inter S.A." },
  { value: '78', label: "78 - Haitong Bi Do Brasil S.A." },
  { value: '79', label: "79 - Banco Original Do Agronegócio S.A." },
  { value: '80', label: "80 - B&T Cc Ltda" },
  { value: '81', label: "81 - Banco Seguro S.A. / Bbn Banco Brasileiro De Negocios S.A." },
  { value: '82', label: "82 - Banco Topázio S.A." },
  { value: '83', label: "83 - Banco Da China Brasil S.A." },
  { value: '84', label: "84 - Uniprime Norte Do Paraná – Cooperativa De Crédito Ltda" },
  { value: '85', label: "85 - Cooperativa Central de Créditos – Ailos" },
  { value: '88', label: "88 - BANCO RANDON S.A." },
  { value: '89', label: "89 - Ccr Reg Mogiana / Credisan Cooperativa De Crédito" },
  { value: '91', label: "91 - Unicred Central Rs" },
  { value: '92', label: "92 - BRK S.A." },
  { value: '93', label: "93 - PóloCred Scmepp Ltda" },
  { value: '94', label: "94 - Banco Finaxis" },
  { value: '95', label: "95 - Travelex Banco de Câmbio S.A." },
  { value: '96', label: "96 - Banco B3 S.A." },
  { value: '97', label: "97 - Credisis – Central de Cooperativas de Crédito Ltda." },
  { value: '98', label: "98 - Credialiança Ccr" },
  { value: '99', label: "99 - Uniprime Central Ccc Ltda" },
  { value: '100', label: "100 - Planner Corretora De Valores S.A." },
  { value: '101', label: "101 - Renascença Dtvm Ltda" },
  { value: '102', label: "102 - XP Investimentos S.A." },
  { value: '104', label: "104 - Caixa Econômica Federal (CEF)" },
  { value: '105', label: "105 - Lecca Cfi S.A." },
  { value: '107', label: "107 - Banco Bocom BBM S.A." },
  { value: '108', label: "108 - Portocred S.A." },
  { value: '111', label: "111 - Banco Oliveira Trust Dtvm S.A." },
  { value: '113', label: "113 - Magliano S.A." },
  { value: '114', label: "114 - Central Cooperativa De Crédito no Estado do Espírito Santo" },
  { value: '117', label: "117 - Advanced Cc Ltda" },
  { value: '118', label: "118 - Standard Chartered Bi S.A." },
  { value: '119', label: "119 - Banco Western Union do Brasil S.A." },
  { value: '120', label: "120 - Banco Rodobens S.A." },
  { value: '121', label: "121 - Banco Agibank S.A." },
  { value: '122', label: "122 - Banco Bradesco BERJ S.A." },
  { value: '124', label: "124 - Banco Woori Bank Do Brasil S.A." },
  { value: '125', label: "125 - Brasil Plural S.A Banco" },
  { value: '126', label: "126 - BR Partners Banco de Investimento S.A." },
  { value: '127', label: "127 - Codepe Cvc S.A." },
  { value: '128', label: "128 - Ms Bank S.A Banco De Câmbio" },
  { value: '129', label: "129 - UBS Brasil Bi S.A." },
  { value: '130', label: "130 - Caruana Scfi" },
  { value: '131', label: "131 - Tullett Prebon Brasil Cvc Ltda" },
  { value: '132', label: "132 - ICBC do Brasil Bm S.A." },
  { value: '133', label: "133 - Cresol Confederação" },
  { value: '134', label: "134 - BGC Liquidez Dtvm Ltda" },
  { value: '136', label: "136 - Unicred Cooperativa LTDA" },
  { value: '137', label: "137 - Multimoney Cc Ltda" },
  { value: '138', label: "138 - Get Money Cc Ltda" },
  { value: '139', label: "139 - Intesa Sanpaolo Brasil S.A." },
  { value: '140', label: "140 - Easynvest – Título Cv S.A." },
  { value: '142', label: "142 - Broker Brasil Cc Ltda" },
  { value: '143', label: "143 - Treviso Cc S.A." },
  { value: '144', label: "144 - Bexs Banco De Cambio S.A." },
  { value: '145', label: "145 - Levycam Ccv Ltda" },
  { value: '146', label: "146 - Guitta Cc Ltda" },
  { value: '149', label: "149 - Facta S.A. Cfi" },
  { value: '157', label: "157 - Icap Do Brasil Ctvm Ltda" },
  { value: '159', label: "159 - Casa do Crédito S.A." },
  { value: '163', label: "163 - Commerzbank Brasil S.A Banco Múltiplo" },
  { value: '169', label: "169 - Banco Olé Bonsucesso Consignado S.A." },
  { value: '172', label: "172 - Albatross Ccv S.A." },
  { value: '173', label: "173 - BRL Trust Dtvm Sa" },
  { value: '174', label: "174 - Pefisa S.A. / Pernambucanas Financ S.A." },
  { value: '177', label: "177 - Guide Investimentos S.A. Corretora de Valores" },
  { value: '180', label: "180 - Cm Capital Markets Cctvm Ltda" },
  { value: '182', label: "182 - Dacasa Financeira S/A" },
  { value: '183', label: "183 - Socred S.A." },
  { value: '184', label: "184 - Banco Itaú BBA S.A." },
  { value: '188', label: "188 - Ativa S.A Investimentos" },
  { value: '189', label: "189 - Hs Financeira" },
  { value: '190', label: "190 - Servicoop" },
  { value: '191', label: "191 - Nova Futura Ctvm Ltda" },
  { value: '194', label: "194 - Parmetal Dtvm Ltda" },
  { value: '196', label: "196 - Banco Fair Cc S.A." },
  { value: '197', label: "197 - Stone Pagamentos S.A." },
  { value: '204', label: "204 - Banco Bradesco Cartoes S.A." },
  { value: '208', label: "208 - Banco BTG Pactual S.A." },
  { value: '212', label: "212 - Banco Original S.A." },
  { value: '213', label: "213 - Bco Arbi S.A." },
  { value: '217', label: "217 - Banco John Deere S.A." },
  { value: '218', label: "218 - Banco Bs2 S.A." },
  { value: '222', label: "222 - Banco Crédit Agricole Br S.A." },
  { value: '224', label: "224 - Banco Fibra S.A." },
  { value: '233', label: "233 - Banco Cifra S.A." },
  { value: '237', label: "237 - Bradesco S.A. / Next Bank" },
  { value: '241', label: "241 - Banco Classico S.A." },
  { value: '243', label: "243 - Banco Máxima S.A." },
  { value: '246', label: "246 - Banco Abc Brasil S.A." },
  { value: '249', label: "249 - Banco Investcred Unibanco S.A." },
  { value: '250', label: "250 - Banco Bcv" },
  { value: '253', label: "253 - Bexs Cc S.A." },
  { value: '254', label: "254 - Paraná Banco S.A." },
  { value: '259', label: "259 - MONEYCORP BANCO DE CÂMBIO S.A." },
  { value: '260', label: "260 - Nu Pagamentos S.A (Nubank)" },
  { value: '265', label: "265 - Banco Fator S.A." },
  { value: '266', label: "266 - Banco Cedula S.A." },
  { value: '268', label: "268 - Barigui Companhia Hipotecária" },
  { value: '269', label: "269 - Hsbc Banco De Investimento" },
  { value: '270', label: "270 - Sagitur Cc Ltda" },
  { value: '271', label: "271 - Ib Cctvm Ltda" },
  { value: '272', label: "272 - AGK Corretora de Câmbio S.A." },
  { value: '273', label: "273 - Ccr De São Miguel Do Oeste" },
  { value: '274', label: "274 - Money Plus Scmepp Ltda" },
  { value: '276', label: "276 - Senff S.A." },
  { value: '278', label: "278 - Genial Investimentos Cvm S.A." },
  { value: '279', label: "279 - Ccr De Primavera Do Leste" },
  { value: '280', label: "280 - Avista S.A." },
  { value: '281', label: "281 - Cooperativa de Crédito Rural Coopavel" },
  { value: '283', label: "283 - RB Capital Investimentos Dtvm Ltda" },
  { value: '285', label: "285 - Frente Cc Ltda" },
  { value: '286', label: "286 - Cooperativa de Crédito Rural de De Ouro" },
  { value: '288', label: "288 - Carol Dtvm Ltda" },
  { value: '289', label: "289 - Decyseo Corretora De Cambio Ltda." },
  { value: '290', label: "290 - PagSeguro Internet S.A." },
  { value: '292', label: "292 - BS2 Distribuidora De Títulos E Investimentos" },
  { value: '293', label: "293 - Lastro Rdv Dtvm Ltda" },
  { value: '296', label: "296 - Vision S.A. Corretora De Cambio" },
  { value: '298', label: "298 - Vip's Cc Ltda" },
  { value: '299', label: "299 - Sorocred Crédito, Financiamento E Investimento S.A." },
  { value: '300', label: "300 - Banco La Nacion Argentina" },
  { value: '301', label: "301 - BPP Instituição De Pagamentos S.A." },
  { value: '306', label: "306 - Portopar Distribuidora De Titulos E Valores Mobiliários Ltda." },
  { value: '307', label: "307 - Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda." },
  { value: '309', label: "309 - Cambionet Corretora De Câmbio Ltda." },
  { value: '310', label: "310 - VORTX Dtvm Ltda" },
  { value: '313', label: "313 - Amazônia Corretora De Câmbio Ltda." },
  { value: '315', label: "315 - PI Distribuidora de Títulos e Valores Mobiliários S.A." },
  { value: '318', label: "318 - Banco BMG S.A." },
  { value: '319', label: "319 - OM Distribuidora De Títulos E Valores Mobiliários Ltda" },
  { value: '320', label: "320 - China Construction Bank – Ccb Brasil S.A." },
  { value: '321', label: "321 - Crefaz Scmepp Ltda" },
  { value: '322', label: "322 - Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz" },
  { value: '323', label: "323 - Mercado Pago – Conta Do Mercado Livre" },
  { value: '324', label: "324 - Cartos Sociedade De Crédito Direto S.A." },
  { value: '325', label: "325 - Órama Distribuidora de Títulos e Valores Mobiliários S.A." },
  { value: '326', label: "326 - Parati – Crédito, Financiamento E Investimento S.A." },
  { value: '329', label: "329 - QI Sociedade de Crédito Direto S.A." },
  { value: '330', label: "330 - Banco Bari de Investimentos e Financiamentos S.A." },
  { value: '331', label: "331 - Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A." },
  { value: '332', label: "332 - Acesso Soluções de Pagamento S.A." },
  { value: '335', label: "335 - Banco Digio S.A." },
  { value: '336', label: "336 - Banco C6 S.A – C6 Bank" },
  { value: '340', label: "340 - Super Pagamentos S/A (Superdital)" },
  { value: '341', label: "341 - Itaú Unibanco S.A." },
  { value: '342', label: "342 - Creditas Sociedade de Crédito Direto S.A." },
  { value: '343', label: "343 - FFA Scmepp Ltda." },
  { value: '348', label: "348 - Banco XP S/A" },
  { value: '349', label: "349 - AL5 S.A. Crédito, Financiamento E Investimento" },
  { value: '350', label: "350 - Cooperativa De Crédito Rural De Pequenos Agricultores E Da Reforma Agrária Do Centro Oeste" },
  { value: '352', label: "352 - Toro Corretora De Títulos E Valores Mobiliários Ltda" },
  { value: '354', label: "354 - Necton Investimentos S.A. Corretora De Valores Mobiliários E Commodities" },
  { value: '355', label: "355 - Ótimo Sociedade De Crédito Direto S.A." },
  { value: '359', label: "359 - Zema Crédito, Financiamento E Investimento S/A" },
  { value: '360', label: "360 - TRINUS Capital Distribuidora De Títulos E Valores Mobiliários S.A." },
  { value: '362', label: "362 - CIELO S.A." },
  { value: '363', label: "363 - Socopa Sociedade Corretora Paulista S.A." },
  { value: '364', label: "364 - Gerencianet S.A." },
  { value: '365', label: "365 - Solidus S.A. Corretora De Cambio E Valores Mobiliarios" },
  { value: '366', label: "366 - Banco Societe Generale Brasil" },
  { value: '367', label: "367 - Vitreo Distribuidora De Títulos E Valores Mobiliários S.A." },
  { value: '368', label: "368 - Banco CSF S.A." },
  { value: '370', label: "370 - Banco Mizuho S.A." },
  { value: '371', label: "371 - Warren Corretora De Valores Mobiliários E Câmbio Ltda." },
  { value: '373', label: "373 - UP.P Sociedade De Empréstimo Entre Pessoas S.A." },
  { value: '374', label: "374 - Realize Crédito, Financiamento E Investimento S.A." },
  { value: '376', label: "376 - Banco J.P. Morgan S.A." },
  { value: '377', label: "377 - MS Scmepp Ltda" },
  { value: '378', label: "378 - BBC Leasing S.A. – Arrendamento Mercantil" },
  { value: '379', label: "379 - Cooperforte – Cooperativa De Economia E Crédito Mútuo" },
  { value: '380', label: "380 - PicPay Servicos S.A." },
  { value: '381', label: "381 - Banco Mercedes-Benz Do Brasil S.A." },
  { value: '382', label: "382 - Fidúcia Scmepp Ltda" },
  { value: '383', label: "383 - Boletobancário.com Tecnologia De Pagamentos Ltda." },
  { value: '384', label: "384 - Global Finanças Scmepp Ltda" },
  { value: '387', label: "387 - Banco Toyota do Brasil S.A." },
  { value: '389', label: "389 - Banco Mercantil Do Brasil S.A." },
  { value: '390', label: "390 - Banco GM S.A." },
  { value: '391', label: "391 - Cooperativa De Crédito Rural De Ibiam – Sulcredi/Ibiam" },
  { value: '393', label: "393 - Banco Volkswagen S.A." },
  { value: '394', label: "394 - Banco Bradesco Financiamentos S.A." },
  { value: '396', label: "396 - Hub Pagamentos S.A." },
  { value: '397', label: "397 - Listo Sociedade De Crédito Direto S.A." },
  { value: '399', label: "399 - Kirton Bank S.A. – Banco Múltiplo" },
  { value: '403', label: "403 - Cora Sociedade De Crédito Direto S.A." },
  { value: '404', label: "404 - SumUp Sociedade De Crédito Direto S.A." },
  { value: '408', label: "408 - Bônuscred Sociedade De Crédito Direto S.A." },
  { value: '412', label: "412 - Banco Capital S.A." },
  { value: '422', label: "422 - Banco Safra S.A." },
  { value: '456', label: "456 - Banco MUFG Brasil S.A." },
  { value: '464', label: "464 - Banco Sumitomo Mitsui Brasil S.A." },
  { value: '473', label: "473 - Banco Caixa Geral Brasil S.A." },
  { value: '477', label: "477 - Citibank N.A." },
  { value: '479', label: "479 - Banco ItauBank S.A." },
  { value: '487', label: "487 - Deutsche Bank S.A (Banco Alemão)" },
  { value: '488', label: "488 - Jpmorgan Chase Bank" },
  { value: '492', label: "492 - Ing Bank N.V." },
  { value: '494', label: "494 - Banco Rep Oriental Uruguay" },
  { value: '495', label: "495 - La Provincia Buenos Aires Banco" },
  { value: '505', label: "505 - Banco Credit Suisse (Brl) S.A." },
  { value: '545', label: "545 - Senso Ccvm S.A." },
  { value: '600', label: "600 - Banco Luso Brasileiro S.A." },
  { value: '604', label: "604 - Banco Industrial Do Brasil S.A." },
  { value: '610', label: "610 - Banco VR S.A." },
  { value: '611', label: "611 - Banco Paulista" },
  { value: '612', label: "612 - Banco Guanabara S.A." },
  { value: '613', label: "613 - Omni Banco S.A." },
  { value: '623', label: "623 - Banco Pan S.A." },
  { value: '626', label: "626 - Banco C6 Consignado S.A. / Banco Ficsa S.A." },
  { value: '630', label: "630 - Banco Intercap S.A. / Banco Smartbank S.A." },
  { value: '633', label: "633 - Banco Rendimento S.A." },
  { value: '634', label: "634 - Banco Triangulo S.A (Banco Triângulo)" },
  { value: '637', label: "637 - Banco Sofisa S.A (Sofisa Direto)" },
  { value: '641', label: "641 - Banco Alvorada S.A." },
  { value: '643', label: "643 - Banco Modal S.A." },
  { value: '644', label: "644 - Banco UBB" },
  { value: '645', label: "645 - Banco Porto Real" },
  { value: '707', label: "707 - Banco Daycoval S.A." },
  { value: '712', label: "712 - Banco Ourinvest S.A." },
  { value: '739', label: "739 - Banco Cetelem S.A." },
  { value: '741', label: "741 - Banco Ribeirão Preto S.A." },
  { value: '743', label: "743 - Banco Semear S.A." },
  { value: '745', label: "745 - Banco Citibank S.A." },
  { value: '746', label: "746 - Banco Modal S.A." },
  { value: '747', label: "747 - Banco Rabobank Internacional Do Brasil S.A." },
  { value: '748', label: "748 - Banco Cooperativa Sicredi S.A." },
  { value: '751', label: "751 - Scotiabank Brasil" },
  { value: '752', label: "752 - Banco BNP Paribas Brasil S.A." },
  { value: '753', label: "753 - Novo Banco Continental S.A Bm" },
  { value: '754', label: "754 - Banco Sistema S.A." },
  { value: '755', label: "755 - Bank of America Merrill Lynch Banco Múltiplo S.A." },
  { value: '756', label: "756 - Bancoob – Banco Cooperativo Do Brasil S.A." },
  { value: '757', label: "757 - Banco Keb Hana Do Brasil S.A." }
];

export const filterBankOption = (input, option) => {
  const search = String(input ?? '').trim().toLowerCase();
  if (!search) return true;
  const label = String(option?.label ?? '').toLowerCase();
  if (label.includes(search)) return true;
  const searchCode = search.replace(/^0+/, '');
  return searchCode !== '' && searchCode !== search && label.includes(searchCode);
};
